import atlassianNavigationDark from './atlassian-navigation.dark.png';
import atlassianNavigationLight from './atlassian-navigation.light.png';
import avatarGroupDark from './avatar-group.dark.png';
import avatarGroupLight from './avatar-group.light.png';
import avatarDark from './avatar.dark.png';
import avatarLight from './avatar.light.png';
import badgeDark from './badge.dark.png';
import badgeLight from './badge.light.png';
import bannerDark from './banner.dark.png';
import bannerLight from './banner.light.png';
import blanketDark from './blanket.dark.png';
import blanketLight from './blanket.light.png';
import boxDark from './box.dark.png';
import boxLight from './box.light.png';
import breadcrumbsDark from './breadcrumbs.dark.png';
import breadcrumbsLight from './breadcrumbs.light.png';
import buttonDark from './button.dark.png';
import buttonLight from './button.light.png';
import calendarDark from './calendar.dark.png';
import calendarLight from './calendar.light.png';
import checkboxDark from './checkbox.dark.png';
import checkboxLight from './checkbox.light.png';
import codeDark from './code.dark.png';
import codeLight from './code.light.png';
import commentDark from './comment.dark.png';
import commentLight from './comment.light.png';
import datetimePickerDark from './datetime-picker.dark.png';
import datetimePickerLight from './datetime-picker.light.png';
import designTokensDark from './design-tokens.dark.png';
import designTokensLight from './design-tokens.light.png';
import drawerDark from './drawer.dark.png';
import drawerLight from './drawer.light.png';
import dropdownMenuDark from './dropdown-menu.dark.png';
import dropdownMenuLight from './dropdown-menu.light.png';
import dynamicTableDark from './dynamic-table.dark.png';
import dynamicTableLight from './dynamic-table.light.png';
import emptyStateDark from './empty-state.dark.png';
import emptyStateLight from './empty-state.light.png';
import flagDark from './flag.dark.png';
import flagLight from './flag.light.png';
import formDark from './form.dark.png';
import formLight from './form.light.png';
import headingDark from './heading.dark.png';
import headingLight from './heading.light.png';
import iconObjectDark from './icon-object.dark.png';
import iconObjectLight from './icon-object.light.png';
import iconDark from './icon.dark.png';
import iconLight from './icon.light.png';
import inlineDialogDark from './inline-dialog.dark.png';
import inlineDialogLight from './inline-dialog.light.png';
import inlineEditDark from './inline-edit.dark.png';
import inlineEditLight from './inline-edit.light.png';
import inlineMessageDark from './inline-message.dark.png';
import inlineMessageLight from './inline-message.light.png';
import inlineDark from './inline.dark.png';
import inlineLight from './inline.light.png';
import logoDark from './logo.dark.png';
import logoLight from './logo.light.png';
import lozengeDark from './lozenge.dark.png';
import lozengeLight from './lozenge.light.png';
import menuDark from './menu.dark.png';
import menuLight from './menu.light.png';
import modalDialogDark from './modal-dialog.dark.png';
import modalDialogLight from './modal-dialog.light.png';
import onboardingDark from './onboarding.dark.png';
import onboardingLight from './onboarding.light.png';
import pageHeaderDark from './page-header.dark.png';
import pageHeaderLight from './page-header.light.png';
import pageLayoutDark from './page-layout.dark.png';
import pageLayoutLight from './page-layout.light.png';
import pageDark from './page.dark.png';
import pageLight from './page.light.png';
import paginationDark from './pagination.dark.png';
import paginationLight from './pagination.light.png';
import popupDark from './popup.dark.png';
import popupLight from './popup.light.png';
import progressBarDark from './progress-bar.dark.png';
import progressBarLight from './progress-bar.light.png';
import progressIndicatorDark from './progress-indicator.dark.png';
import progressIndicatorLight from './progress-indicator.light.png';
import progressTrackerDark from './progress-tracker.dark.png';
import progressTrackerLight from './progress-tracker.light.png';
import radioDark from './radio.dark.png';
import radioLight from './radio.light.png';
import rangeDark from './range.dark.png';
import rangeLight from './range.light.png';
import sectionMessageDark from './section-message.dark.png';
import sectionMessageLight from './section-message.light.png';
import selectDark from './select.dark.png';
import selectLight from './select.light.png';
import sideNavigationDark from './side-navigation.dark.png';
import sideNavigationLight from './side-navigation.light.png';
import skeletonDark from './skeleton.dark.png';
import skeletonLight from './skeleton.light.png';
import spinnerDark from './spinner.dark.png';
import spinnerLight from './spinner.light.png';
import stackDark from './stack.dark.png';
import stackLight from './stack.light.png';
import tabDark from './tab.dark.png';
import tabLight from './tab.light.png';
import tableTreeDark from './table-tree.dark.png';
import tableTreeLight from './table-tree.light.png';
import tagGroupDark from './tag-group.dark.png';
import tagGroupLight from './tag-group.light.png';
import tagDark from './tag.dark.png';
import tagLight from './tag.light.png';
import textareaDark from './textarea.dark.png';
import textareaLight from './textarea.light.png';
import textfieldDark from './textfield.dark.png';
import textfieldLight from './textfield.light.png';
import toggleDark from './toggle.dark.png';
import toggleLight from './toggle.light.png';
import tooltipDark from './tooltip.dark.png';
import tooltipLight from './tooltip.light.png';

export default {
	box: {
		light: boxLight,
		dark: boxDark,
	},
	inline: {
		light: inlineLight,
		dark: inlineDark,
	},
	stack: {
		light: stackLight,
		dark: stackDark,
	},
	onboarding: {
		light: onboardingLight,
		dark: onboardingDark,
	},
	menu: {
		light: menuLight,
		dark: menuDark,
	},
	'inline-message': {
		light: inlineMessageLight,
		dark: inlineMessageDark,
	},
	comment: {
		light: commentLight,
		dark: commentDark,
	},
	tooltip: {
		light: tooltipLight,
		dark: tooltipDark,
	},
	calendar: {
		light: calendarLight,
		dark: calendarDark,
	},
	button: {
		light: buttonLight,
		dark: buttonDark,
	},
	'avatar-group': {
		light: avatarGroupLight,
		dark: avatarGroupDark,
	},
	'icon-object': {
		light: iconObjectLight,
		dark: iconObjectDark,
	},
	page: {
		light: pageLight,
		dark: pageDark,
	},
	popup: {
		light: popupLight,
		dark: popupDark,
	},
	'page-layout': {
		light: pageLayoutLight,
		dark: pageLayoutDark,
	},
	'progress-bar': {
		light: progressBarLight,
		dark: progressBarDark,
	},
	'section-message': {
		light: sectionMessageLight,
		dark: sectionMessageDark,
	},
	textarea: {
		light: textareaLight,
		dark: textareaDark,
	},
	breadcrumbs: {
		light: breadcrumbsLight,
		dark: breadcrumbsDark,
	},
	textfield: {
		light: textfieldLight,
		dark: textfieldDark,
	},
	avatar: {
		light: avatarLight,
		dark: avatarDark,
	},
	range: {
		light: rangeLight,
		dark: rangeDark,
	},
	code: {
		light: codeLight,
		dark: codeDark,
	},
	'modal-dialog': {
		light: modalDialogLight,
		dark: modalDialogDark,
	},
	logo: {
		light: logoLight,
		dark: logoDark,
	},
	'dropdown-menu': {
		light: dropdownMenuLight,
		dark: dropdownMenuDark,
	},
	'inline-dialog': {
		light: inlineDialogLight,
		dark: inlineDialogDark,
	},
	'page-header': {
		light: pageHeaderLight,
		dark: pageHeaderDark,
	},
	form: {
		light: formLight,
		dark: formDark,
	},
	blanket: {
		light: blanketLight,
		dark: blanketDark,
	},
	flag: {
		light: flagLight,
		dark: flagDark,
	},
	tag: {
		light: tagLight,
		dark: tagDark,
	},
	'design-tokens': {
		light: designTokensLight,
		dark: designTokensDark,
	},
	'tag-group': {
		light: tagGroupLight,
		dark: tagGroupDark,
	},
	'atlassian-navigation': {
		light: atlassianNavigationLight,
		dark: atlassianNavigationDark,
	},
	'progress-tracker': {
		light: progressTrackerLight,
		dark: progressTrackerDark,
	},
	tab: {
		light: tabLight,
		dark: tabDark,
	},
	checkbox: {
		light: checkboxLight,
		dark: checkboxDark,
	},
	'progress-indicator': {
		light: progressIndicatorLight,
		dark: progressIndicatorDark,
	},
	select: {
		light: selectLight,
		dark: selectDark,
	},
	'datetime-picker': {
		light: datetimePickerLight,
		dark: datetimePickerDark,
	},
	radio: {
		light: radioLight,
		dark: radioDark,
	},
	pagination: {
		light: paginationLight,
		dark: paginationDark,
	},
	toggle: {
		light: toggleLight,
		dark: toggleDark,
	},
	lozenge: {
		light: lozengeLight,
		dark: lozengeDark,
	},
	spinner: {
		light: spinnerLight,
		dark: spinnerDark,
	},
	'empty-state': {
		light: emptyStateLight,
		dark: emptyStateDark,
	},
	drawer: {
		light: drawerLight,
		dark: drawerDark,
	},
	'side-navigation': {
		light: sideNavigationLight,
		dark: sideNavigationDark,
	},
	badge: {
		light: badgeLight,
		dark: badgeDark,
	},
	'inline-edit': {
		light: inlineEditLight,
		dark: inlineEditDark,
	},
	heading: {
		light: headingLight,
		dark: headingDark,
	},
	'dynamic-table': {
		light: dynamicTableLight,
		dark: dynamicTableDark,
	},
	'table-tree': {
		light: tableTreeLight,
		dark: tableTreeDark,
	},
	banner: {
		light: bannerLight,
		dark: bannerDark,
	},
	skeleton: {
		light: skeletonLight,
		dark: skeletonDark,
	},
	icon: {
		light: iconLight,
		dark: iconDark,
	},
};
